<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
    v-model="TAB"
  >
    <vs-tab
      icon-pack="feather"
      icon="icon-list"
      :label="!isSmallerScreen ? $t(`ANALITICS.listAnalitics`) : ''"
      @click="goToEdit(null, 0)"
    >
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <AnaliticsList @key="goToEdit($event, 1)" />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? textTab : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <AnaliticsForm :keyStatistic="key" @key="goToEdit(null, 0)" />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import AnaliticsList from "./AnaliticsList";
import AnaliticsForm from "./newAnaliticsForns.vue";

export default {
  components: {
    AnaliticsList,
    AnaliticsForm
  },
  data() {
    return {
      key: null,
      TAB: 0
    };
  },
  methods: {
    goToEdit(key, tab) {
      this.key = key;
      this.TAB = tab;
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isEdit() {
      return this.key !== null;
    },
    textTab() {
      return this.isEdit ? this.$t(`ANALITICS.editAnalitics`) : this.$t(`ANALITICS.newAnalitics`);
    }
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
